(function () {
    const gridContainer = document.getElementById('flexible-grid');
    const gridVariants = [3, 6, 9, 12];

    if (gridContainer) {
        document.querySelectorAll('.section-news__grid-variant').forEach(element => {
            element.addEventListener('click', (e) => {
                selectGrid(parseInt(element.innerText), e);
            });
        });
    }

    function selectGrid(columns = 3, event) {
        if (!gridVariants.includes(columns)) {
            console.log('Grid not exists');
            return;
        }
        document.querySelector('.section-news__grid-variant--active').classList.remove('section-news__grid-variant--active');
        event.target.classList.add('section-news__grid-variant--active');

        removeOldGrid();
        gridContainer.classList.add('grid--' + columns);
    }

    function removeOldGrid() {
        gridContainer.classList.remove('grid--3');
        gridContainer.classList.remove('grid--6');
        gridContainer.classList.remove('grid--9');
        gridContainer.classList.remove('grid--12');
        for (const variant of gridVariants) {
            gridContainer.classList.remove('grid--' + variant);
        }
    }
})();